import $ from 'jquery';

export default function() {
  
  $(".intro-drag").each(function() {
    var $this=$(this);
    var $drag=$this.find(".drag-icon");
    var lastX=0, lastY=0;
    $this.mousemove(function(e) {
      lastX=e.pageX;
      lastY=e.pageY;
      $drag.css({left: e.pageX, top: e.pageY-$this.offset().top});
    });
    setTimeout(()=>{
      appScrollbar.addListener(function() {
        $drag.css({left: lastX, top: lastY-$this.offset().top});
      });
    }, 1000);
    var isDragging=false;
    var startPoint=false;
    var dragLog=[];
    var offset=0;
    var ulx=$this.find(".drag-carousel-scale>ul");
    var lis=$this.find(".drag-carousel-scale>ul>li");
    var animDrag=$this.find("[data-animdrag]");
    var isTouch=false;
    $drag.css({top: "calc(50% + 20px)", left: "calc(50%)"}).addClass("visible intro-anim");
    $(document).on("touchstart", function() {
      isTouch=true;
      $drag.removeClass("visible");
    });
    $this.find(".drag-carousel-scale").hover(function(e) {
      if (!isTouch);
      $drag.addClass("visible");
    }, function(e) {
      $drag.removeClass("visible");
    });
    
    var startDrag=function(arg) {
      isDragging=arg;
      startPoint=arg;
      dragLog=[arg];
      $drag.addClass("active");      
    }
    
    var moveDrag=function(arg) {
      var liWidth=lis.eq(0).innerWidth()+30;
      offset+=arg.left-isDragging.left;
      isDragging=arg;
      dragLog.push(arg);
      if (dragLog.length>10)
        dragLog.shift();
      ulx.css("transform", "translateX("+offset+"px)").css("transition", "0s");
      animDrag.each(function() {
        var liIndex=lis.index($(this).closest("li"));
        var offset2=offset+liIndex*liWidth;
        var multiplier=$(this).attr("data-animdrag")*1 || 0;
        $(this).css("transform", "translateX("+(offset2*multiplier)+"px)").css("transition", "0s");
      });
      var liOffsets=[];
      for(var i=0;i<lis.length;i++)
        liOffsets.push(i*liWidth+offset);
      var closestIndex=0;
      var closest=10000;
      for(var i in liOffsets)
        if (closest>Math.abs(liOffsets[i])) {
          closest=Math.abs(liOffsets[i]);
          closestIndex=i;
        }
      var item=lis.eq(closestIndex);
      $this.attr("class", "intro fullsc intro-drag "+(item.attr("data-mode") || "")).css("background", item.attr("data-color"));
    }
    
    var stopDrag=function(arg) {
      var liWidth=lis.eq(0).innerWidth()+30;
      $drag.removeClass("active");
      var ul=$this.find(".drag-carousel-scale ul")[0];
//       if (offset>0) {
//         offset=0;
//         ulx.css("transform", "translateX("+offset+"px)").css("transition", ".3s");
//       }
//       if (offset<-(ul.scrollWidth-ul.clientWidth)) {
//         offset=-(ul.scrollWidth-ul.clientWidth);
//         ulx.css("transform", "translateX("+offset+"px)").css("transition", ".3s");
//       }
      isDragging=false;
      var dragFirst=dragLog[0];
      dragLog=[];
      var dragLast=arg;
      var dragSpeed=(dragLast.left-dragFirst.left)/(dragLast.ts-dragFirst.ts+1);
      var liOffsets=[];
      for(var i=0;i<lis.length;i++)
        liOffsets.push(i*liWidth+offset+Math.max(-1.5, Math.min(1.5, dragSpeed))*liWidth/3);
      var closestIndex=0;
      var closest=10000;
      for(var i in liOffsets)
        if (closest>Math.abs(liOffsets[i])) {
          closest=Math.abs(liOffsets[i]);
          closestIndex=i;
        }
      offset=-closestIndex*liWidth;
      ulx.css("transform", "translateX("+offset+"px)").css("transition", ".3s");
      animDrag.each(function() {
        var liIndex=lis.index($(this).closest("li"));
        var offset2=offset+liIndex*liWidth;
        var multiplier=$(this).attr("data-animdrag")*1 || 0;
        $(this).css("transform", "translateX("+(offset2*multiplier)+"px)").css("transition", ".3s");
      });
      var item=lis.eq(closestIndex);
      $this.attr("class", "intro fullsc intro-drag "+(item.attr("data-mode") || "")).css("background", item.attr("data-color"));
    }

    $this.attr("class", "intro fullsc intro-drag "+(lis.eq(0).attr("data-mode") || "")).css("background", lis.eq(0).attr("data-color"));

    $this.find(".drag-carousel-scale").mousedown(function(e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      startDrag({left: e.pageX, top: e.pageY, ts: e.timeStamp});
    });
    $(document).mousemove(function(e) {
      if (isDragging) {
        e.stopImmediatePropagation();
        e.preventDefault();
        moveDrag({left: e.pageX, top: e.pageY, ts: e.timeStamp});
      } else {
        $drag.removeClass("intro-anim");
        lastX=e.pageX;
        lastY=e.pageY;
        $drag.css({left: e.pageX, top: e.pageY-$this.offset().top});
      }
    });
    $(document).mouseup(function(e) {
      if (isDragging) {
        e.stopImmediatePropagation();
        e.preventDefault();
        stopDrag({left: e.pageX, top: e.pageY, ts: e.timeStamp});
      }
    });
    
    
    // Touch support
    $this.find(".drag-carousel-scale").on("touchstart", function(e) {
      startDrag({left: e.touches[0].pageX, top: e.touches[0].pageY, ts: e.timeStamp});
    });
    $(document).on("touchmove", function(e) {
      if (isDragging) {
        var horizontalEnough=true;
        if (horizontalEnough) {
//           e.stopImmediatePropagation();
        }
        moveDrag({left: e.touches[0].pageX, top: e.touches[0].pageY, ts: e.timeStamp});
      }
    });
    $(document).on("touchend", function(e) {
      console.lo
      if (isDragging) {
        stopDrag({left: isDragging.left, top: isDragging.top, ts: e.timeStamp});
      }
    });
  });

  


}


